// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-large {
  width: 870px;
}

.dialog-medium {
  width: 600px;
}

.dialog-small {
  width: 400px;
}

.dialog-small-medium {
  width: 480px;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/ui/Dialogs/Dialog.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":[".dialog-large {\n  width: 870px;\n}\n\n.dialog-medium {\n  width: 600px;\n}\n\n.dialog-small {\n  width: 400px;\n}\n\n.dialog-small-medium {\n  width: 480px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
